import {StokListe} from './stok-liste';

export class StokListePage {

  currentPage: number;
  pageCount: number;
  pageSize: number;
  rowCount: number;
  firstRowOnPage: number;
  lastRowOnPage: number;
  private pResults: StokListe[];


  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
  }

  public get results(): StokListe[] {
    return this.pResults;
  }

  public set results(list: StokListe[]) {
    if (list != null) {
      this.pResults = list.map(t => new StokListe(t));
    }
  }

}
